import { Component, ElementRef, OnInit } from '@angular/core';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams } from 'ag-grid-community';

import { trackById } from '../../util/track-by.util';

import { IIdLabel } from './../../interfaces/common.interface';

interface IOptionParams extends IIdLabel {
  isDefault :boolean;
}

@Component({
  selector: 'app-ag-grid-custom-radio-filter',
  templateUrl: './ag-grid-custom-radio-filter.component.html',
})
export class AgGridCustomRadioFilterComponent
  implements IFilterAngularComp, OnInit
{
  params :any;
  options :IOptionParams[] = [];
  selectedValue :number | string = 'None';
  trackById = trackById;

  ngOnInit() :void {
    this.options = this.params.values;
    const defaultSelectedValue = this.params.values?.find(
      (option :IOptionParams) => option.isDefault,
    );
    if (defaultSelectedValue) {
      this.selectedValue = defaultSelectedValue.id;
    }
  }

  onReset() :void {
    this.selectedValue = 'None';
    this.params.filterChangedCallback();
  }

  onRadioChange(event :MatRadioChange) :void {
    this.selectedValue = event.value;
    this.params.filterChangedCallback();
  }

  agInit(params :any) :void {
    this.params = params;
  }

  getGui() :HTMLElement {
    return this.elementRef.nativeElement;
  }

  isFilterActive() :boolean {
    return this.selectedValue !== undefined;
  }

  doesFilterPass(params :IDoesFilterPassParams) :boolean {
    const value = params.data[this.params.colDef.field];

    return value === this.selectedValue;
  }

  setModel(model :any) :void {
    this.selectedValue = model;
  }

  getModel() :any {
    return this.selectedValue;
  }

  constructor(private elementRef :ElementRef) {}
}
